import { render } from "./LightBoxModal.vue?vue&type=template&id=dd707f7a&lang=html"
import script from "./LightBoxModal.vue?vue&type=script&lang=js"
export * from "./LightBoxModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/peterdevos/Apps/sendcloudholidaygiftsraffle/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__